import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import TeamTwo from "../blocks/team/TeamTwo";
import Breadcrumb from "../elements/common/Breadcrumb";
import WhatsAppButton from "../component/WhatsAppButton";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

import { withTranslation } from 'react-i18next';

class Process extends Component {
    render() {

        const { t } = this.props;

        return (
            <React.Fragment>
                <PageHelmet pageTitle = {t("Procesos")}/>

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title = {t("Procesos")} />
                {/* End Breadcrump Area */}

                {/* Start Team Area */}
                <div className="rn-team-area ptb--80 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="text-center">
                                <TeamTwo column="col-lg-2" teamStyle="" item={6} position="end" />
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Team Area */}

                {/* Start Whatsapp Button */}
                <div>
                    <WhatsAppButton />
                </div>
                {/* End Whatsapp Button */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}

export default withTranslation()(Process);